import React, { useEffect, useState, useMemo, useReducer } from 'react'

import { Box, Alert, AlertTitle, IconButton, Button, Tooltip } from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import AddBotDialog from "./AddBotDialog/index.js"
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha/index.js';
import useNotification from "../../Notification/index.js";
import Loading from '../../Loading/index.js';
import api from '../../../api.js';
import defaultReducer from '../../../utils/defaultReducer.js'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { getSession } from '../../../auth.js';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

export const FacebookPlugin = ({ reloadState, reload, setConnectedPage, english, app, setManagedPages = () => {} }) => {

	const SCOPE_PERMISSIONS = {
		DEFAULT: [
			"business_management",
			"pages_manage_metadata",
			"pages_show_list",
			"pages_messaging",
			"pages_read_engagement",
			"instagram_basic",
			"instagram_manage_messages",
		].join(","),

		WHATSAPP: [
			"whatsapp_business_messaging",
			"whatsapp_business_management",
		].join(","),
	};

	const [state, setState] = useReducer(defaultReducer, {
		loggedin: false,
		loading: true
	})

	useMemo(async () => {
		(function (d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) { return; }
			js = d.createElement(s); js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	}, [])

	const getAppData = async (key) => {
		return (await api.get(`api/getEnv/${key}/`)).data
	}

	useEffect(() => {
		try {
			window.fbAsyncInit()
		} catch (e) {
			console.error(e);
		}
	}, [reload])
	
	const getManagedPages = async (userAccessToken) => {
		return new Promise((resolve, reject) => {
			FB.api(
				'/me/accounts',
				'GET',
				{
					fields: 'id,name,access_token',
					access_token: userAccessToken,
				},
				(response) => {
					if (!response || response.error) {
						reject(
							new Error(
								response?.error?.message ||
								'Não foi possível carregar as páginas do Facebook.'
							)
						);
						return;
					}

					resolve(response.data || []);
				}
			);
		});
	};

	window.reloadWindowOnKwik = () => {
		reloadState()
	}

	window.fbAsyncInit = async function () {

		const checkForFB = async () => {
			return new Promise((resolve) => {
				const check = () => {
					if (typeof FB !== 'undefined') {
						resolve()
					} else {
						setTimeout(check, 1000)
					}
				}
				check()
			});
		};

		await checkForFB()

		const data = await getAppData(app ?? 'INSTAGRAM')

		FB.init({
			appId: data['app_id'],
			cookie: true,
			xfbml: true,
			version: data['app_version']
		});

		FB.AppEvents.logPageView();

		FB.getLoginStatus(async function (response) {
			setConnectedPage(response)
			statusChangeCallback(response);

			if (response.status === 'connected') {
				try {
					const pages = await getManagedPages(
						response.authResponse.accessToken
					);

					setManagedPages(pages);
				} catch (error) {
					console.error('Erro ao buscar páginas:', error.message);
				}
			}
		});
	};

	const statusChangeCallback = (data) => {
		const response = { 'loggedin': false }
		if (data.status === 'connected') {
			response['loggedin'] = true
		}
		response['loading'] = false
		setState(response)
	}
	return (
		(
			<Box sx={{ padding: '1rem' }}>
				{state.loading && <Box><AutorenewIcon className={'fileIcon spinner'} /></Box>}
				<Box key={state.loading} sx={{ display: state.loading || state.loggedin ? 'none' : '' }}>
					<div id="fb-root"></div>
					<div class="fb-login-button"
						data-width=""
						data-size=""
						data-button-type=""
						data-layout=""
						data-onlogin="reloadWindowOnKwik()"
						data-auto-logout-link="false"
						data-use-continue-as="true"
						scope={SCOPE_PERMISSIONS[app] ?? SCOPE_PERMISSIONS['DEFAULT']}
					></div>
				</Box>
				{!state.loading && state.loggedin && !english && <Box>Você já está logado com o facebook <Button variant='text' onClick={() => { FB.logout(); reloadState(); }}>Deslogar</Button></Box>}
				{!state.loading && state.loggedin && english && <Box>You already logged in facebook <Button variant='text' onClick={() => { FB.logout(); reloadState(); }}>Logout</Button></Box>}
			</Box>
		)
	)
}


const Instagram = ({ enterprise }) => {

	const user = getSession()

	const [loading, setLoading] = useState(false);
	const [bots, setBots] = useState([]);
	const [showAddBot, setShowAddBot] = useState(false)
	const [deleteModal, setDeleteModal] = useState(null)
	const [connectedPage, setConnectedPage] = useState(null)
	const [reload, setReload] = useState(false)

	const [managedPages, setManagedPages] = useState([])

	const reloadState = () => { setTimeout(() => setReload(p => !p), 500) }

	const deleteBot = async (id) => {
		let resInstagram = null;
		let resMessenger = null;
		const enterpriseId = getSession().profile.enterprise.id;
		setLoading(true);

		const deleteRequests = Array.isArray(id) ?
			id.map(item => {
				if ('id_instagram' in item) {
					return api.delete(`/api/enterprises/${enterpriseId}/instagram/${item.id}/`).then(res => ({ type: 'instagram', res }));
				} else {
					return api.delete(`/api/enterprises/${enterpriseId}/messenger/${item.id}/`).then(res => ({ type: 'messenger', res }));
				}
			}) :
			['id_instagram' in id ?
				api.delete(`/api/enterprises/${enterpriseId}/instagram/${id.id}/`).then(res => ({ type: 'instagram', res })) :
				api.delete(`/api/enterprises/${enterpriseId}/messenger/${id.id}/`).then(res => ({ type: 'messenger', res }))
			];

		try {
			const results = await Promise.all(deleteRequests);

			results.forEach(({ type, res }) => {
				if (type === 'instagram') resInstagram = res;
				if (type === 'messenger') resMessenger = res;
			});

			if ((resInstagram && resInstagram.status !== 204) || (resMessenger && resMessenger.status !== 204)) {
				useNotification(
					'Ops!',
					'Ocorreu um erro na requisição.',
					'danger'
				);
				return;
			}

			// const idsToDelete = Array.isArray(id) ? id.map(item => item.id) : [id.id];
			// setBots(bots.filter((bot) => !idsToDelete.includes(bot.id)));
			fetchData()
			setDeleteModal(null);
		} catch (error) {
			console.error(error);
			useNotification(
				'Ops!',
				'Ocorreu um erro na requisição.',
				'danger'
			);
		} finally {
			setLoading(false);
		}
	};

	const getIntegrationErrorMessage = (response, version) => {
		const status = response?.status;
		const data = response?.data;
		const facebookError = data?.facebook_error;
		const facebookMessage = facebookError?.message || data?.detail;

		// Errors with specific business meaning
		switch (status) {
			case 404:
				return version === 1
					? 'Não foi possível vincular a página. Verifique se você concedeu as permissões necessárias à Instant Solutions.'
					: 'Não foi possível vincular a página. Verifique se ela foi adicionada ao Gerenciador de Negócios e se o usuário de sistema "Kwik" tem as permissões necessárias.';

			case 405:
				return 'Não foi possível encontrar uma conta profissional do Instagram vinculada a esta página do Facebook. Verifique a integração entre as contas.';

			case 406:
				return 'Não foi possível configurar a assinatura do webhook. Verifique as permissões do aplicativo ou entre em contato com um administrador do sistema.';

			case 409:
				return 'Esta página não pode ser vinculada porque já está vinculada a outra conta.';

			case 410:
				return 'Usuário não autorizado. Esta operação só pode ser executada pela equipe do Kwik.';

			case 400:
			case 401:
			case 403:
			case 502:
				if (facebookMessage) {
					return `A Meta recusou a solicitação: ${facebookMessage}`;
				}
				return 'Não foi possível autenticar com a Meta. Verifique o token de acesso e as permissões concedidas ao aplicativo.';

			default:
				if (facebookMessage) {
					return `Erro na integração com a Meta: ${facebookMessage}`;
				}
				return 'Ocorreu um erro ao tentar vincular a página. Tente novamente ou entre em contato com o suporte.';
		}
	};
	
	const addBot = async (page_id, version) => {
		const enterpriseId = getSession().profile.enterprise.id;

		setLoading(true);

		try {
			const payload = {
				page_id,
				token_page: connectedPage?.authResponse?.accessToken,
				version,
			};

			const [resInstagram, resMessenger] = await Promise.all([
				api.post(`/api/enterprises/${enterpriseId}/instagram/`, {
					...payload,
					id_instagram: '-',
				}),
				api.post(`/api/enterprises/${enterpriseId}/messenger/`, payload),
			]);

			const instagramSuccess = resInstagram.status === 201;
			const messengerSuccess = resMessenger.status === 201;

			if (!instagramSuccess || !messengerSuccess) {
				// If either integration succeeded, keep the successful
				// integration and report the failure of the other one.
				const failedResponse = !instagramSuccess
					? resInstagram
					: resMessenger;

				useNotification(
					'Ops!',
					getIntegrationErrorMessage(failedResponse, version),
					'danger'
				);

				if (instagramSuccess || messengerSuccess) {
					fetchData();
				}

				return;
			}

			fetchData();
			setShowAddBot(false);
		} catch (error) {
			const response = error?.response;

			useNotification(
				'Ops!',
				getIntegrationErrorMessage(response, version),
				'danger'
			);
		} finally {
			setLoading(false);
		}
	};


	const managePageData = (resInstagram, resMessenger) => {
		let res = []
		let controlResInsta = []
		let controlResMesse = []
		if ((resInstagram.data.length > 0 && resMessenger.data.length > 0)) {
			resInstagram.data.forEach((item_insta) => {
				let resIn = []
				resMessenger.data.forEach((item_messe) => {
					if (item_insta.page_id == item_messe.page_id) {
						resIn.push(item_insta)
						resIn.push(item_messe)
						res.push(resIn)
						controlResInsta.push(item_insta.id)
						controlResMesse.push(item_messe.id)
					} else {
						if (!controlResMesse.includes(item_messe.id)) {
							res.push(item_messe)
							controlResMesse.push(item_messe.id)
						}
					}
				})
				if (!controlResInsta.includes(item_insta.id)) {
					res.push(item_insta)
					controlResInsta.push(item_insta.id)
				}
			})
		}

		else if (resMessenger.data.length > 0) {
			res.push(resMessenger.data)
		}

		else if (resInstagram.data.length > 0) {
			res.push(resInstagram.data)
		}

		return res
	}

	const fetchData = async () => {
		const enterpriseId = getSession().profile.enterprise.id;
		setLoading(true);
		const resInstagram = await api.get(`/api/enterprises/${enterpriseId}/instagram/`);
		const resMessenger = await api.get(`/api/enterprises/${enterpriseId}/messenger/`);
		setLoading(false);

		if (resInstagram.status !== 200 && resMessenger.status !== 200) {
			useNotification(
				'Ops!',
				'Não foi possível encontrar as páginas.',
				'danger'
			);
			return
		}

		const res = managePageData(resInstagram, resMessenger)

		setBots(res)
	};

	useEffect(() => {
		fetchData()
	}, [])

	const facebookPlugin = useMemo(() => {
		return (<FacebookPlugin reloadState={reloadState} reload={reload} setConnectedPage={setConnectedPage} setManagedPages={setManagedPages} />)
	}, [reload])

	if (!enterprise?.platforms?.instagram) {
		return (
			<Box>
				<Alert severity="info">
					Entre em contato com seu gerente de contas para contratar o canal Instagram / Messenger - <a href="https://wa.link/0bs73j">Clique aqui.</a>
				</Alert>
			</Box>
		)
	}

	return (
		<Box className="input-settings settings-body">
			<Loading loading={loading} />
			{showAddBot &&
				<AddBotDialog
					open={showAddBot}
					handleClose={() => setShowAddBot(false)}
					version={showAddBot}
					submit={(page_id) => addBot(page_id, showAddBot)}
					managedPages={managedPages.filter((page) =>
						!bots
							.flat()
							.some((bot) => String(bot.page_id) === String(page.id))
					)}
				/>
			}
			{deleteModal ?
				<ConfirmationDialogCaptcha open={true}
					title="Excluir página."
					description={
						<span>
							Para confirmar a ação, digite: <span style={{ 'fontWeight': 'bold' }}>remover</span> no campo abaixo.</span>}
					handleClose={() => { setDeleteModal(null) }}
					handleSubmit={() => { deleteBot(deleteModal) }}
					captcha={'remover'}
				/> : null
			}
			<Alert className="telegram-info" severity="info">
				<AlertTitle>
					Para saber como integrar o kwik com o Instagram e/ou Messenger, clique no canal desejado abaixo.
				</AlertTitle>
				<Box>
					<p>
						<a href="https://instant.getoutline.com/s/80b32544-e1bc-4f61-a9a0-96388c8d42b1" target="_blank">Instagram</a>
					</p>
					<p>
						<a href="https://instant.getoutline.com/s/77871958-d9cc-4c68-a48a-0d55ab71e3dd" target="_blank">Messenger</a>
					</p>
				</Box>
				<Box className="push-s-bottom">
					É necessário:
				</Box>
				<Box>
					<p>Uma conta empresarial no facebook.</p>
					<p>Uma página no facebook.</p>
					<p>Uma conta empresarial no Instagram.</p>
					<p>Vincular sua página do facebook ao Instagram.</p>
					<p>Ceder permissões ao Kwik, clicando no botão abaixo: {facebookPlugin}</p>
				</Box>
				<Box className="push-s-top">
					Você pode adicionar sua página clicando no botão abaixo.
				</Box>
			</Alert>
			{bots.length !== 0 &&
				<>
					<Box className="category-title push-bottom push-top">
						Páginas vinculadas
					</Box>
					<Box className="telegram-bots">
						<table>
							{bots.map((item, index) => (
								<tr>
									{Array.isArray(item) &&
										<>
											<td>{item[0].page_name} - {item[0].page_id}</td>
											{item.map((page, page_index) => (
												<td>{'id_instagram' in page ?
													<InstagramIcon className="instagram" sx={{ marginBottom: '-5px!important' }} />
													:
													<FacebookIcon className="messenger" sx={{ marginBottom: '-5px!important' }} />}</td>
											))}
										</>
									}
									{!Array.isArray(item) &&
										<>
											<td>{item.page_name} - {item.page_id}</td>
											<td>{'id_instagram' in item ?
												<InstagramIcon className="instagram" sx={{ marginBottom: '-5px!important' }} />
												:
												<FacebookIcon className="messenger" sx={{ marginBottom: '-5px!important' }} />}</td>
											<td></td>
										</>
									}
									<td>
										<IconButton>
											<DeleteIcon onClick={() => {
												setDeleteModal(item)
											}} />
										</IconButton>
									</td>
								</tr>
							))}
						</table>
					</Box>
				</>
			}
			<Box className="telegram-mumbers-info" sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'flex-start' }}>
				<Tooltip title={!connectedPage?.authResponse?.accessToken ? 'Conecte a página do facebook para poder adicionar páginas.' : ''}>
				<span>
					<LoadingButton
						startIcon={<AddIcon />}
						variant="contained"
						onClick={() => setShowAddBot(1)}
						disabled={!connectedPage?.authResponse?.accessToken}
					>
						Adicionar
					</LoadingButton>
				</span>
				</Tooltip>
				{(user.username.includes('@instant.com.br')) &&
					<LoadingButton
						color="success"
						startIcon={<AddIcon />}
						variant="contained"
						onClick={() => setShowAddBot(2)}
					>
						Adicionar sem login
					</LoadingButton>}
			</Box>

		</Box>
	)
}

export default Instagram
